__turbopack_context__.v({
  "container-page": "UZ4LHq_container-page",
  "form-greeting": "UZ4LHq_form-greeting",
  "image-content": "UZ4LHq_image-content",
});
